import { render, staticRenderFns } from "./PlayerCard.vue?vue&type=template&id=67e0c5eb"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"
import style0 from "./PlayerCard.vue?vue&type=style&index=0&id=67e0c5eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports